// Seeded RNG (mulberry32) and scramble generation.

export function mulberry32(seed) {
  let a = seed >>> 0;
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function hashString(str) {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function makeRng(seed) {
  if (typeof seed === "string") return mulberry32(hashString(seed));
  if (seed === undefined || seed === null)
    return mulberry32((Math.random() * 0xffffffff) >>> 0);
  return mulberry32(seed >>> 0);
}

// Random integer in [0, n)
export function randInt(rng, n) {
  return Math.floor(rng() * n);
}
